import { put } from 'redux-saga/effects'
import { deleteLabelAction } from '../../handles'
import { deleteLabel } from '../_http/label'
import { toast } from '@/helpers/toast/toast.helper'
import { t } from 'i18next'

export function* deleteLabelSaga(action: ReturnType<typeof deleteLabelAction.request>) {
  const { labelId } = action.payload
  try {
    yield deleteLabel(labelId)
    yield put(deleteLabelAction.success({ labelId }))
    toast({ type: 'success', message: t('translation:deleteLabelSuccess') })
  } catch (error) {
    console.error('Error deleting label:', error)
    if (error?.response?.data?.errorCode === 'LABEL_IN_USE') {
      toast({ type: 'error', message: t('translation:deleteLabelError') })
    }
    yield put(deleteLabelAction.failure())
  }
}
